import React from 'react';
import { array, func, string } from 'prop-types';

import Checkbox from '@material-ui/core/Checkbox';

const SelectAllCheckbox = ({
    deselectAllLabel,
    items,
    onItemChange,
    selectAllLabel
}) => {
    const someSelected = items.some(({ isSelected }) => isSelected);
    const someUnselected = items.some(({ isSelected }) => !isSelected);
    const allSelected = someSelected && !someUnselected;
    const indeterminate = someSelected && someUnselected;
    let ariaLabel = selectAllLabel;
    if (indeterminate || allSelected) {
        ariaLabel = deselectAllLabel;
    }

    function handleToggleAll(event) {
        let isSelected = !allSelected;
        if (someSelected) {
            isSelected = false;
        }
        items.forEach(({ id }) => onItemChange(id, { isSelected }));
    }

    return (
        <Checkbox
            checked={allSelected}
            onChange={handleToggleAll}
            color="primary"
            indeterminate={indeterminate}
            inputProps={{
                'aria-label': ariaLabel
            }}
        />
    );
};

SelectAllCheckbox.defaultProps = {
    deselectAllLabel: 'Deselect All',
    items:            [],
    onItemChange:     () => {},
    selectAllLabel:   'Select All'
};

SelectAllCheckbox.propTypes = {
    deselectAllLabel: string,
    items:            array,
    onItemChange:     func,
    selectAllLabel:   string
};

export default SelectAllCheckbox;
